import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="bg-gray-900 text-gray-400 pt-10 pb-6 mt-8">
    <div className="container mx-auto px-4 max-w-5xl">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-8">

        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <p className="text-white text-xl font-bold mb-2">Minto</p>
          <p className="text-sm leading-relaxed mb-4">
            Doorstep mobile repair in Mumbai. Certified technicians, genuine parts, 90-day warranty.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.instagram.com/minto_repairs/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center hover:bg-minto-500 transition-colors"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram text-sm"></i>
            </a>
            <a
              href="https://www.youtube.com/@mintorepair"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center hover:bg-minto-500 transition-colors"
              aria-label="YouTube"
            >
              <i className="fab fa-youtube text-sm"></i>
            </a>
            <a
              href="https://wa.me/+919324299258"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center hover:bg-green-500 transition-colors"
              aria-label="WhatsApp"
            >
              <i className="fab fa-whatsapp text-sm"></i>
            </a>
          </div>
        </div>

        {/* Repair Areas */}
        <div>
          <p className="text-white text-sm font-semibold mb-2">Western Line</p>
          <ul className="space-y-1 text-xs mb-3">
            {[
              { to: '/mobile-repair-lower-parel', label: 'Lower Parel' },
              { to: '/mobile-repair-dadar', label: 'Dadar' },
              { to: '/mobile-repair-bandra', label: 'Bandra' },
              { to: '/mobile-repair-vile-parle', label: 'Vile Parle' },
              { to: '/mobile-repair-andheri', label: 'Andheri' },
              { to: '/mobile-repair-goregaon', label: 'Goregaon' },
              { to: '/mobile-repair-malad', label: 'Malad' },
              { to: '/mobile-repair-borivali', label: 'Borivali' },
            ].map((a) => (
              <li key={a.to}><Link to={a.to} className="hover:text-minto-400 transition-colors">{a.label}</Link></li>
            ))}
          </ul>
          <p className="text-white text-xs font-semibold mb-1">Central Line</p>
          <ul className="space-y-1 text-xs mb-3">
            {[
              { to: '/mobile-repair-kurla', label: 'Kurla' },
              { to: '/mobile-repair-ghatkopar', label: 'Ghatkopar' },
              { to: '/mobile-repair-thane', label: 'Thane' },
            ].map((a) => (
              <li key={a.to}><Link to={a.to} className="hover:text-minto-400 transition-colors">{a.label}</Link></li>
            ))}
          </ul>
          <p className="text-white text-xs font-semibold mb-1">Harbour Line</p>
          <ul className="space-y-1 text-xs">
            {[
              { to: '/mobile-repair-chembur', label: 'Chembur' },
              { to: '/mobile-repair-navi-mumbai', label: 'Navi Mumbai' },
            ].map((a) => (
              <li key={a.to}><Link to={a.to} className="hover:text-minto-400 transition-colors">{a.label}</Link></li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <p className="text-white text-sm font-semibold mb-3">Services</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/screen-replacement" className="hover:text-minto-400 transition-colors">Screen Replacement</Link></li>
            <li><Link to="/battery-replacement" className="hover:text-minto-400 transition-colors">Battery Replacement</Link></li>
            <li><Link to="/charging-port-repair" className="hover:text-minto-400 transition-colors">Charging Port Repair</Link></li>
            <li><Link to="/speaker-mic-repair" className="hover:text-minto-400 transition-colors">Speaker / Mic Repair</Link></li>
            <li><Link to="/software-repair" className="hover:text-minto-400 transition-colors">Software Issues</Link></li>
          </ul>
        </div>

        {/* Company & Contact */}
        <div>
          <p className="text-white text-sm font-semibold mb-3">Company</p>
          <ul className="space-y-2 text-sm mb-4">
            <li><Link to="/about" className="hover:text-minto-400 transition-colors">About Us</Link></li>
            <li><Link to="/faq" className="hover:text-minto-400 transition-colors">FAQ</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-minto-400 transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms-conditions" className="hover:text-minto-400 transition-colors">Terms & Conditions</Link></li>
            <li><Link to="/refunds-cancellations" className="hover:text-minto-400 transition-colors">Refunds</Link></li>
          </ul>
          <a
            href="tel:+919324299258"
            className="flex items-center gap-2 text-sm hover:text-minto-400 transition-colors"
          >
            <i className="fas fa-phone text-xs"></i>
            +91 93242 99258
          </a>
        </div>
      </div>

      <div className="border-t border-gray-800 pt-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs">
        <p>© {new Date().getFullYear()} Minto — Prajapati Technologies Pvt. Ltd.</p>
        <p>GST: 27AAJCP4476F1Z4</p>
      </div>
    </div>
  </footer>
);

export default Footer;
